export const LOCAL_AGENTS_HOST = "agents.localhost";
export const PROD_AGENTS_HOST = "agents.atw.net";
export const PROD_AGENTS_PAGES_PREVIEW = "atw-agents.pages.dev";

export function isAtwAgentsPublicHost(hostname: string): boolean {
  const h = hostname.split(":")[0].toLowerCase();
  return h === PROD_AGENTS_HOST || h === LOCAL_AGENTS_HOST;
}

export function isAtwAgentsPagesPreviewHost(hostname: string): boolean {
  const h = hostname.split(":")[0].toLowerCase();
  return h === PROD_AGENTS_PAGES_PREVIEW;
}

export function localDevPortSuffix(origin?: string): string {
  if (typeof window !== "undefined" && window.location.port) {
    return `:${window.location.port}`;
  }
  const from = origin || import.meta.env.VITE_AGENTS_ORIGIN || "";
  try {
    const u = new URL(from);
    return u.port ? `:${u.port}` : "";
  } catch {
    return "";
  }
}

export function atwAgentsAppOrigin(): string {
  if (typeof window !== "undefined") {
    const h = window.location.hostname.toLowerCase();
    if (isAtwAgentsPublicHost(h) || isAtwAgentsPagesPreviewHost(h)) {
      return `${window.location.protocol}//${window.location.host}`;
    }
    if (h === "localhost" || h === "127.0.0.1" || h.endsWith(".localhost")) {
      return `http://${LOCAL_AGENTS_HOST}${localDevPortSuffix()}`;
    }
  }
  return `https://${PROD_AGENTS_HOST}`;
}

export function atwAgentsAppUrl(path = "/"): string {
  const normalized = !path || path === "/" ? "/" : path.startsWith("/") ? path : `/${path}`;
  return `${atwAgentsAppOrigin()}${normalized === "/" ? "/" : normalized}`;
}

/** In-app href on the Agents host (short paths). */
export function agentsHref(shortPath: string): string {
  const normalized =
    !shortPath || shortPath === "/" ? "/" : shortPath.startsWith("/") ? shortPath : `/${shortPath}`;
  return normalized;
}
